import React, { FunctionComponent, useCallback } from 'react';
import FormGroup from 'ui/molecules/form-group';
import { useFilterOption } from 'ui/molecules/filtering/hooks';
import type { FilterOptionSelectionProps } from 'ui/molecules/filtering/types';
import { StyledMultiSelect } from './styled';
import Icon from 'src/ui/atoms/icon';

export interface MultiSelectItem {
  value: string;
  label: string;
  name: string;
}

export const FilterMultiSelect: FunctionComponent<FilterOptionSelectionProps> = (props) => {
  const { label, options, placeholder, onSearch, input, loading } = props;
  const { value: selection, setValue: setSelection } = useFilterOption(props, []);

  const onSelect = useCallback(
    (selectedList: MultiSelectItem[]) => {
      setSelection(selectedList.map((item) => item.value));
    },
    [selection],
  );

  const selectedValues = options.filter(({ value }) =>
    Array.isArray(selection) ? selection.includes(value) : selection === value,
  );

  return (
    <FormGroup label={label}>
      <StyledMultiSelect
        id={input}
        options={options}
        displayValue="label"
        selectedValues={selectedValues}
        placeholder={placeholder || ''}
        showArrow={true}
        onSelect={(selectedList: MultiSelectItem[]) => onSelect(selectedList)}
        onRemove={(selectedList: MultiSelectItem[]) => onSelect(selectedList)}
        onSearch={onSearch ? (value: any) => onSearch(value) : undefined}
        {...(loading && { emptyRecordMsg: <Icon name="spinner" loading={true} color="primary" /> })}
      />
    </FormGroup>
  );
};

export default FilterMultiSelect;
